import MediaUploader from './MediaUploader';

export default MediaUploader;
